import React from 'react';
import { COLOR } from '@src/styles/color';
import Typography from '@src/new-components/Typography';

const StepIndicator = ({ totalSteps, currentStep }) => {
  if (totalSteps === 1) return null;

  return (
    <Typography variant="body-14-regular" color={COLOR.label2[64]}>
      {`${currentStep + 1}/${totalSteps}`}
    </Typography>
  );
};
export default StepIndicator;
